var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4688 3.38137C8.79307 3.38137 3.38137 8.79307 3.38137 15.4688C3.38137 22.1444 8.79307 27.5561 15.4688 27.5561C22.1444 27.5561 27.5561 22.1444 27.5561 15.4688C27.5561 8.79307 22.1444 3.38137 15.4688 3.38137ZM0.46875 15.4688C0.46875 7.18448 7.18448 0.46875 15.4688 0.46875C23.753 0.46875 30.4688 7.18448 30.4688 15.4688C30.4688 23.753 23.753 30.4688 15.4688 30.4688C7.18448 30.4688 0.46875 23.753 0.46875 15.4688Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0328 9.56371C14.3746 9.21462 12.9251 10.4614 12.9251 12.0513C12.9251 12.8556 12.2731 13.5076 11.4688 13.5076C10.6645 13.5076 10.0125 12.8556 10.0125 12.0513C10.0125 8.65196 13.1239 5.97713 16.6292 6.7128C18.7116 7.14154 20.3785 8.80841 20.8072 10.8908C21.3846 13.642 19.8595 16.1458 17.5373 17.0971C17.1905 17.2408 16.9154 17.6256 16.9154 18.1095C16.9154 18.9138 16.2634 19.5658 15.4591 19.5658C14.6548 19.5658 14.0027 18.9138 14.0027 18.1095C14.0027 16.5552 14.892 15.0374 16.4281 14.404L16.4319 14.4024C17.5247 13.9553 18.231 12.7918 17.9563 11.4872L17.9548 11.4798C17.7612 10.5361 16.984 9.75883 16.0402 9.56524L16.0328 9.56371Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9251 22.1775C16.9251 21.3732 16.2731 20.7212 15.4688 20.7212C14.6645 20.7212 14.0125 21.3732 14.0125 22.1775V23.1483C14.0125 23.9526 14.6645 24.6047 15.4688 24.6047C16.2731 24.6047 16.9251 23.9526 16.9251 23.1483V22.1775Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.4dfc80b0218c60ac99278f13845fc115.svg";
export { ForwardRef as ReactComponent };